import './Navigation.css'
import Logo from '../../Shared/Logo/Logo.png'
import NoUserWhite from '../../Shared/Images/NoUserWhite.png'
import { useState, useContext } from 'react'
import { Link } from 'react-router-dom'
import { AuthContext } from '../../Context/AuthContext'
import Installer from '../Installer/Installer'
import PostAddIcon from '@material-ui/icons/PostAdd'
import LibraryBooksIcon from '@material-ui/icons/LibraryBooks'
import PeopleAltIcon from '@material-ui/icons/PeopleAlt'
import CreateIcon from '@material-ui/icons/Create'
import DarkModeIcon from '@material-ui/icons/Brightness4'
import LightModeIcon from '@material-ui/icons/Brightness7'
import { ThemeContext } from '../../Context/ThemeContext'
import { AppContext } from '../../Context/AppContext'
import React from 'react'

const Navigation = () => {
  const authCtx = useContext(AuthContext)
  const Theme = useContext(ThemeContext)
  const App = useContext(AppContext)

  const [open, setOpen] = useState(false)

  const closeMenu = () => setOpen(false)
  const toggleMenu = () => setOpen((v) => !v)

  const toggleTheme = () => {
    const next = !Theme.Theme.isDark
    Theme.setTheme({ isDark: next })
    localStorage.setItem('isDark', JSON.stringify(next))
  }

  // Starting a brand-new invoice: clear any edit context so we never
  // overwrite or duplicate an existing invoice.
  const handleNewInv = () => {
    closeMenu()
    App?.setApp({ ...App.app, newInv: true, editId: null, renderInv: false })
  }

  const isUser = !!authCtx?.auth.isUser
  const userPic = isUser ? authCtx!.auth.user!.photoURL! : NoUserWhite
  const userName = isUser ? authCtx!.auth.user!.displayName! : 'Inicia sesión'

  return (
    <>
      <header className="Navbar">
        <button
          className={open ? 'Burger open' : 'Burger'}
          onClick={toggleMenu}
          aria-label="Menú"
          aria-expanded={open}
        >
          <span></span>
          <span></span>
          <span></span>
        </button>

        <Link to="/" className="navBrand" onClick={closeMenu}>
          <img src={Logo} width="34" height="34" alt="Facturator" />
          <span>Facturator</span>
        </Link>

        <Link
          to={isUser ? '/mydata' : '/signin'}
          onClick={closeMenu}
          className="navUserLink"
        >
          <img
            className="NavUserPic"
            width="36"
            height="36"
            alt={userName}
            src={userPic}
          />
        </Link>
      </header>

      <div
        className={open ? 'navOverlay open' : 'navOverlay'}
        onClick={closeMenu}
      ></div>

      <nav className={open ? 'sidebarMenu open' : 'sidebarMenu'}>
        <Link
          onClick={closeMenu}
          className="sidebarUser"
          to={isUser ? '/mydata' : '/signin'}
        >
          <img src={userPic} alt={userName} />
          <span>{userName}</span>
        </Link>

        <Link onClick={handleNewInv} className="BarLink" to="/newinvoice">
          <PostAddIcon className="BarIcon" /> Nueva factura
        </Link>
        <Link onClick={closeMenu} className="BarLink" to="/myinvoices">
          <LibraryBooksIcon className="BarIcon" /> Mis facturas
        </Link>
        <Link onClick={closeMenu} className="BarLink" to="/myclients">
          <PeopleAltIcon className="BarIcon" /> Mis clientes
        </Link>
        <Link onClick={closeMenu} className="BarLink" to="/mydata">
          <CreateIcon className="BarIcon" /> Mis datos
        </Link>

        <Installer />

        <button className="themeToggle" onClick={toggleTheme}>
          {Theme.Theme.isDark ? <LightModeIcon /> : <DarkModeIcon />}
          {Theme.Theme.isDark ? 'Modo claro' : 'Modo oscuro'}
        </button>
      </nav>
    </>
  )
}

export default Navigation
